export default __webpack_public_path__ + "static/media/rear-right-wheel.0b155351.svg";